export default __webpack_public_path__ + "static/media/Sprint.01ada058.png";